import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import RTVDialog from './RTVDialog';
import BlueexpressLogo from '../../images/blueExpressCompleteLogo.webp';
import RtvButton from '../Buttons/RtvButton';
import { makeStyles } from '@material-ui/core/styles';
import { USER_PRIVATE_STATS_RETRIEVED } from '../../redux/actions/types';

const useStyles = makeStyles(theme => ({
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      textWrapMode: 'noWrap',
      fontSize: '1rem',
      justifyContent: 'space-between'
    }
  },
  logo: {
    [theme.breakpoints.down('sm')]: {
      width: '40%'
    }
  },
  actionSectionContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    gap: '2rem',
    [theme.breakpoints.down('sm')]: {
      gap: '1rem'
    }
  },
  actionSectionButton: {
    minWidth: '150px',
    paddingInline: '0.5rem',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100px'
    }
  },
  configButton: {
    color: 'black'
  },
  message: {
    textAlign: 'center',
    fontSize: '1rem',
    maxWidth: '335px',
    marginBlock: '0px'
  }
}));

const RTVBlueExpressDialog = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const onConfirm = () => setShowModal(false);
  const onClose = () => setShowModal(false);
  const onConfig = () => {
    setShowModal(false);
    dispatch(push('/configuracion/medios-de-envio'));
  };
  const totalProducts = useSelector(
    state => state.user.privateStats.total_products
  );
  const status = useSelector(state => state.user.status);

  useEffect(() => {
    if (
      status &&
      status === USER_PRIVATE_STATS_RETRIEVED &&
      totalProducts &&
      totalProducts > 0 &&
      !window.localStorage.getItem('RTV-hasSeenBlueExpress')
    ) {
      setShowModal(true);
      window.localStorage.setItem('RTV-hasSeenBlueExpress', true);
    }
  }, [dispatch, status, totalProducts]);
  return (
    <RTVDialog
      padding={'1rem 2rem'}
      fullScreen={false}
      open={showModal}
      onClose={() => onClose()}
      title={
        <div className={classes.titleContainer}>
          <span>NUEVO CORREO</span>
          <img
            className={classes.logo}
            alt="Blue express carrier Logo"
            src={BlueexpressLogo}
          ></img>
        </div>
      }
      content={
        <p className={classes.message}>
          Sumamos una nueva forma de envío para ofrecer mejores precios.
          <br></br> Ya estás ofreciendo este medio de envío, en caso que quieras
          desactivarlo puedes hacerlo desde Configuración {'>'} Medios de envío
        </p>
      }
      actionSection={
        <div className={classes.actionSectionContainer}>
          <RtvButton
            onClick={() => onConfig()}
            className={`${classes.actionSectionButton} ${classes.configButton}`}
            variant={'secondary'}
          >
            Configurar
          </RtvButton>
          <RtvButton
            onClick={() => onConfirm()}
            className={classes.actionSectionButton}
            variant={'rtvRed'}
          >
            Ok
          </RtvButton>
        </div>
      }
    />
  );
};

export default RTVBlueExpressDialog;
